export var MuiInputOverrides = {
  styleOverrides: {
    root: {
      fontSize: '1rem',
      fontWeight: 400,
      letterSpacing: '0.15px',
      lineHeight: '128%'
    }
  }
};
export var MuiFormHelperTextOverrides = {
  styleOverrides: {
    root: {
      fontSize: '0.75rem',
      fontWeight: 400,
      letterSpacing: '0.4px',
      lineHeight: '142%'
    }
  }
};